import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
// import image2 from '../../img/chnagesBg5.png';
import image2 from '../../img/slider2/2.png';
import image3 from '../../img/slider2/3.png';
import image1 from '../../img/slider2/1.png';

class SliderDashboard extends React.Component {


    render() {
        return (
            <Carousel showArrows={true}  infiniteLoop={true}  showThumbs={false} autoPlay={true}    interval={10000}>
                <div>
                    <img alt="conga" src={image1}   />
                    <p className="legends">Conga Automation Framework is a polyglot framework that supports multiple programming languages</p>
                </div>
                <div>
                    <img  alt="conga" src={image2} />
                    <p className="legends fs26">With Conga Automation UI, you can configure to view upto 10 projects in a single point with essential data right on your home screens</p>
                </div>
                <div>
                    <img alt="conga" src={image3} />
                    <p className="legends">Did you know that Conga Automation Framework runs 18000 tests everday</p>
                </div>
            </Carousel>
        );
    }
}
export default SliderDashboard;